import provider from "./src/providers/provider"

import "firebase/analytics"
export const wrapRootElement = provider
